var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-popup",
    {
      attrs: {
        fullscreen: "",
        active: _vm.show,
        title: "Unidades da Matriz " + _vm.cnpj
      },
      on: {
        "update:active": function($event) {
          _vm.show = $event
        }
      }
    },
    [
      _c("div", { staticClass: "flex flex-col gap-2 pb-4" }, [
        _c("div", { staticClass: "flex flex-col gap-1" }, [
          _c("label", { staticClass: "font-bold" }, [
            _vm._v("Matriz Nome Fantasia")
          ]),
          _vm._v(
            " " + _vm._s(_vm._.get(_vm.legal_entity, "trading_name")) + " "
          )
        ]),
        _c("div", { staticClass: "flex flex-col gap-1" }, [
          _c("label", { staticClass: "font-bold" }, [
            _vm._v("Matriz Razão Social")
          ]),
          _vm._v(
            " " + _vm._s(_vm._.get(_vm.legal_entity, "company_name")) + " "
          )
        ])
      ]),
      _c(
        "vs-table",
        {
          staticClass: "h-full",
          attrs: { data: _vm.legal_units },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(ref) {
                var data = ref.data
                return _vm._l(data, function(tr, i) {
                  return _c(
                    "vs-tr",
                    { key: data[i], class: "_data-viewer_" + tr.key },
                    [
                      _c("vs-td", [_vm._v(" " + _vm._s(tr.id) + " ")]),
                      _c("vs-td", [
                        _vm._v(" " + _vm._s(tr.trading_name) + " ")
                      ]),
                      _c("vs-td", [
                        _vm._v(" " + _vm._s(tr.company_name) + " ")
                      ]),
                      _c("vs-td", [
                        _vm._v(" " + _vm._s(tr.cnpj_formmated) + " ")
                      ])
                    ],
                    1
                  )
                })
              }
            }
          ])
        },
        [
          _c(
            "template",
            { slot: "thead" },
            [
              _c("vs-th", { attrs: { "sort-key": "id" } }, [_vm._v("ID")]),
              _c("vs-th", { attrs: { "sort-key": "trading_name" } }, [
                _vm._v("Nome Fantasia")
              ]),
              _c("vs-th", { attrs: { "sort-key": "company_name" } }, [
                _vm._v("Razão Social")
              ]),
              _c("vs-th", { attrs: { "sort-key": "cnpj" } }, [_vm._v("CNPJ")])
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }